import React from 'react';
import { AonDialog } from '../../components/core/AonDialog';
import { UuiLogo } from '@aonunited/react';
import { AonButton } from '../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../components/core/AonButton/consts';
import './S&PDialog.scss';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var ConfirmationDailog = function (props) {
    var Footer = function () {
        return React.createElement("div", null,
            React.createElement(AonButton, { style: { marginInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, disabled: props.loader, onClick: props.onConfirm }, "Confirm"),
            React.createElement(AonButton, { style: { marginInline: "5px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: props.onDenie }, "Cancel"));
    };
    var Body = function () {
        return React.createElement("div", null,
            React.createElement("div", { className: 'SP-text-container' }, props.confirmationMessage ? props.confirmationMessage : " Are you sure you want to proceed with the selection ?"));
    };
    return (React.createElement(AonDialog, { extraClass: 'aon-dialog-confirmation', dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDialog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
            React.createElement("div", { className: 'logo_about_dialog' },
                React.createElement(UuiLogo, { onClick: function () { } })),
            React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onDenie, icon: faClose })), body: React.createElement(Body, null), footer: React.createElement(Footer, null) }));
};
export default ConfirmationDailog;
